function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CookieMonster from './CookieMonster';
/**
 * The GdprSettings component is a wrapper around the Cookie Monster JS component for
 * prompting users for consent to use cookies to conform with GDPR legislation
 *
 * - [CookieMonster Docs](https://confluence.sie.sony.com/display/ID/CookieMonster+API+spec)
 *
 * ## TODO
 * - [ ] normalize supported language into standard format?
 *
 * ## Configuration
 *
 * For client only usage the component can be statically configured. configuring via props should
 * be preferred except for `npEnvironment` which is shared across all instances.
 *
 * ```js
 * GdprSettings.configure({
 *   domain: '.playstation.com',
 *   npEnvironment: 'e1-np',
 *   country: 'US',
 *   language: 'en_US',
 * });
 * ```
 *
 * Configure also can accept an instance that implements the CookieMonster client interface
 *
 * ```js
 * GdprSettings.configure({
 *   instance,
 * });
 * ```
 *
 * ## Usage
 *
 * Show full UI regardless of users cookie preference
 *
 * ```jsx
 * <GdprSettings
 *  type="full"
 *  country="GB"
 *  language="en_GB"
 *  force
 * />
 * ```
 *
 * ## Props
 */

var GdprSettings = /*#__PURE__*/function (_PureComponent) {
  _inherits(GdprSettings, _PureComponent);

  var _super = _createSuper(GdprSettings);

  _createClass(GdprSettings, null, [{
    key: "configure",
    value: function configure(config) {
      GdprSettings.config = config;
    }
  }]);

  function GdprSettings(props) {
    var _this;

    _classCallCheck(this, GdprSettings);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var onChange = _this.props.onChange;
      onChange(event);
    });

    _defineProperty(_assertThisInitialized(_this), "_promptPrivacyConsent", function () {
      var _this$props = _this.props,
          type = _this$props.type,
          force = _this$props.force,
          country = _this$props.country,
          language = _this$props.language,
          disableFixedTop = _this$props.disableFixedTop;

      _this.cm.promptForPrivacyPreference({
        type: type,
        force: force,
        language: language,
        country: country,
        disableFixedTop: disableFixedTop,
        element: _this._node.current
      });
    });

    _this._node = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(GdprSettings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isSSR = (typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object';
      if (isSSR) return;
      var instance = GdprSettings.config.instance;
      this.cm = instance || new CookieMonster(GdprSettings.config);

      this._promptPrivacyConsent();

      this._off = this.cm.on('privacyConsentChange', this._onChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._promptPrivacyConsent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._off();
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      return /*#__PURE__*/React.createElement("div", {
        ref: this._node,
        "data-qa": "gdpr-setting",
        className: className
      });
    }
  }]);

  return GdprSettings;
}(PureComponent);

_defineProperty(GdprSettings, "config", {});

export default GdprSettings;
GdprSettings.defaultProps = {
  className: '',
  type: 'full',
  force: false,
  disableFixedTop: false,
  country: '',
  language: '',
  onChange: function onChange() {}
};
GdprSettings.propTypes = {
  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Type of UI to show. See cookie monster docs for details on each value
   */
  type: PropTypes.oneOf(['full', 'setting-only', 'none']),

  /**
   * The users country (e.g US)
   */
  country: PropTypes.string,

  /**
   * The users language to display the cookie monster UI in (e.g. en_US)
   */
  language: PropTypes.string,

  /**
   * Whether or not to always show UI regardless of prior setting. See cookie monster
   * docs for usage
   */
  force: PropTypes.bool,

  /**
   * Whether or not to disable fixed position at top right
   */
  disableFixedTop: PropTypes.bool,

  /**
   * event callback to be called when the user changes their preference
   */
  onChange: PropTypes.func
};